import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { customerConfig } from '@uxdf/direct-shared-lib';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IsDecisionMakerGuard implements CanActivate {
  constructor(private readonly store: Store<any>) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(customerConfig),
      take(1),
      map(customerState => {
        console.warn('IsDecisionMakerGuard canActivate: ' + customerState.customerConfig.is_decision_maker);
        return customerState.customerConfig.is_decision_maker;
      })
    );
  }
}
